import { graphql } from 'gatsby'
import { IPostNode } from '../types/postsListing'
import Layout from '../components/Layout'
import Container from '../components/container'
import BlogPost from '../components/BlogPost'
import SEO from '../components/seo'

interface BlogPostProps {
  data: { post: IPostNode }
  errors: Error[]
  location: { href: string }
}

export const query = graphql`
  query BlogPostTemplateQuery($id: String!) {
    post: sanityPost(id: { eq: $id }) {
      id
      publishedAt
      updatedOn
      categories {
        id
        name
        title
        slug {
          current
        }
      }
      mainImage {
        ...SanityImage
        alt
      }
      title
      slug {
        current
      }
      excerpt
      _rawBody(resolveReferences: { maxDepth: 5 })
      authors {
        _key
        author {
          image {
            crop {
              _key
              _type
              top
              bottom
              left
              right
            }
            hotspot {
              _key
              _type
              x
              y
              height
              width
            }
            asset {
              _id
            }
          }
          name
          _rawBio(resolveReferences: { maxDepth: 5 })
        }
      }
    }
  }
`

function BlogPostTemplate({ data, errors, location }: BlogPostProps) {
  const post = data?.post

  if (errors) {
    console.error('GraphQL errors:', errors)
    return (
      <Layout>
        <Container>
          <h1>Error</h1>
          <p>
            An error occurred while loading the blog post. Please try again
            later.
          </p>
        </Container>
      </Layout>
    )
  }

  if (!post) {
    console.error('No post data found')
    return (
      <Layout>
        <Container>
          <h1>Not Found</h1>
          <p>The requested blog post could not be found.</p>
        </Container>
      </Layout>
    )
  }

  return (
    <Layout>
      <BlogPost {...post} url={location.href} />
    </Layout>
  )
}

export function Head({ data }: Pick<BlogPostProps, 'data'>) {
  if (!data.post) {
    console.error('No post data found for SEO')
    return null
  }

  return (
    <SEO
      title={data.post.title || 'Untitled'}
      description={data.post.excerpt}
      image={data.post.mainImage}
    />
  )
}

export default BlogPostTemplate
